import { Component } from '@angular/core';
import { fadeInAnimation } from '@animations/fade-in.animation';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [fadeInAnimation],
  host: { '[@fadeInAnimation]': '' }
})
export class AppComponent {

  constructor(
    private translateService: TranslateService,
  ) {
    this.translateService.use('en');
  }

  title = 'ihost-feedback';
}
